import type { CSSProperties } from 'react';
import { brandColors, brandRgba, brandShadowRgba } from '@shared/constants';
import { formTokens } from './form-kit';

const SHADOW = `0 2px 8px ${brandShadowRgba('textPrimary', 0.1)}, 0 1px 2px ${brandShadowRgba('textPrimary', 0.06)}, inset 0 1px 0 ${brandShadowRgba('surfaceCard', 0.6)}`;

/** Tint behind a filter that is narrowing the list, and behind its chosen option. */
export const FILTER_ACTIVE_BG = brandRgba('brandPrimary', 0.06);

/** The pill every list-page filter dropdown uses; `active` means it is narrowing the list. */
export function filterPillStyle({
  active,
  open,
  fullWidth,
  disabled,
}: {
  active: boolean;
  open: boolean;
  fullWidth?: boolean;
  disabled?: boolean;
}): CSSProperties {
  return {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 9,
    width: fullWidth ? '100%' : undefined,
    padding: '12px 20px',
    borderRadius: formTokens.fieldRadius,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: active || open ? formTokens.brand : formTokens.borderStrong,
    background: active ? FILTER_ACTIVE_BG : brandRgba('surfaceCard', 0.85),
    color: active || open ? formTokens.brand : formTokens.text1,
    boxShadow: SHADOW,
    fontSize: 14,
    fontWeight: 700,
    whiteSpace: 'nowrap',
    cursor: disabled ? 'not-allowed' : 'pointer',
    opacity: disabled ? 0.55 : 1,
    transition: 'color .2s ease, border-color .2s ease, background .2s ease',
  };
}

/** The panel a filter pill opens. */
export const filterPopupStyle: CSSProperties = {
  borderRadius: formTokens.fieldRadius,
  border: `1px solid ${formTokens.border}`,
  background: brandColors.surfaceCard,
  boxShadow: `0 16px 40px ${brandShadowRgba('textPrimary', 0.16)}`,
  overflow: 'hidden',
};
